//Types
export const Types = {
  CREATE_USER: "CREATE_USER",
  UPDATE_USER: "UPDATE_USER",
  GET_USER: "GET_USER",
  GET_USERS: "GET_USERS",
  GET_TECHNICAL_RESPONSIBLE_USERS: "GET_TECHNICAL_RESPONSIBLE_USERS",
  DELETE_USER: "DELETE_USER",
  ACCESS_HISTORY: "ACCESS_HISTORY",
  SET_LOADING: "SET_LOADING_USER",
}

//Reducer
const initialState = {
  users: null,
  technicalResponsibleUsers: null,
  user: null,
  loading: false,
  accessHistory: null,
}

const Users = (state = initialState, action) => {
  switch (action.type) {
    case Types.CREATE_USER:
      return {
        ...state,
        user: action.payload
      }

    case Types.UPDATE_USER:
      return {
        ...state,
        users: action.payload,
        user: action.payload, 
      }

    case Types.GET_USER:
      return {
        ...state,
        user: action.payload,
        loading: false
      }

    case Types.GET_USERS:
      return {
        ...state,
        users: action.payload,
        loading: false
      }

    case Types.GET_TECHNICAL_RESPONSIBLE_USERS:
      return {
        ...state,
        technicalResponsibleUsers: action.payload,
        loading: false
      }

    case Types.DELETE_USER:
      return {
        ...state,
        users: action.payload
      }
    case Types.ACCESS_HISTORY:
      return {
        ...state,
        accessHistory: action.payload,
        loading: false
      }

    case Types.SET_LOADING:
      return {
        ...state,
        loading: true
      }

    default:
      return state;
  }
}

export default Users;
